module.exports = __webpack_public_path__ + "media/images/flags/64/Switzerland-7f575b606c93d072fc4a06f26c5821b5.png";